<template>
  <Badge class="OfferCardBadge" type="neutral" size="sm"><slot /></Badge>
</template>

<script>
import Badge from '~/aasgard/components/feedback/Badge.vue'

export default {
  name: 'OfferCardBadge',
  components: { Badge },
}
</script>

<style lang="scss"></style>
